<template>
    <div class="mt-12">
        <h3 class="text-xl font-bold leading-none mt-3 text-custom-member">
        ภาพรวมโครงการ
        </h3>
        <div class="grid grid-cols-12 gap-6 mt-2">
            <div
                class="report-box-2 col-span-12 sm:col-span-4 mt-2"
                :class="[i.shadow]"
                v-for="(i, k) in boxCard"
                :key="k"
            >
                <div class="box sm:flex" :class="[i.bg, i.color]">
                    <div class="px-4 py-4 flex flex-col justify-center flex-1 bg-white opacity-30 items-center" style="height: 112px;" v-if="!i.count">
                        <div class="w-8 h-8">
                        <LoadingIcon
                            icon="three-dots"
                            class="w-8 h-8 loading-icon"
                        />
                        </div>
                    </div>
                    <div class="px-4 py-4 flex flex-col justify-center flex-1" v-else>
                        <div class="flex items-center justify-between">
                        <span>{{ i.text }}</span>

                        <span
                            class="
                            w-8
                            h-8
                            px-2
                            py-2
                            flex
                            items-center
                            justify-center
                            rounded-full
                            bg-white
                            text-theme-17
                            ml-2
                            box-shadow
                            "
                        >
                            <HomeIcon
                            class="block mx-auto !stroke-2 stroke-[#90C4C4]"
                            v-if="i.icon == 'house'"
                            />
                            <UsersIcon
                            class="block mx-auto !stroke-2 stroke-[#7EA6D1]"
                            v-if="i.icon == 'family'"
                            />
                            <UserIcon
                            class="block mx-auto !stroke-2 stroke-[#15286C]"
                            v-if="i.icon == 'member'"
                            />
                        </span>
                        </div>

                        <div class="relative text-5xl font-medium ml-0.5" style="min-height: 48px;">
                        {{ i.count ? new Intl.NumberFormat().format(i.count): null }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive, watch } from "vue"
const props = defineProps({
    dataOverview: Object
})
watch(()=> props.dataOverview, (val)=>{
    if(val){
        boxCard[0].count = val.household_total?.length>0 ? val.household_total[0] : 0
        boxCard[1].count = val.family_total?.length>0 ? val.family_total[0] : 0
        boxCard[2].count = val.member_total?.length>0 ? val.member_total[0] : 0
    }
})
const boxCard = reactive([
    {
        text: "จำนวนครัวเรือน",
        bg: "bg-custom-household",
        count: null,
        shadow: "before:bg-custom-hshadow",
        color: "text-custom-member",
        icon: "house",
    },
    {
        text: "จำนวนครอบครัว",
        bg: "bg-custom-family",
        count: null,
        shadow: "before:bg-custom-fshadow",
        color: "text-custom-member",
        icon: "family",
    },
    {
        text: "จำนวนสมาชิก",
        bg: "bg-custom-member",
        count: null,
        shadow: "before:bg-custom-mshadow",
        color: "text-white",
        icon: "member",
    },
]);
</script>

<style>

</style>